import { useQuery } from '@tanstack/react-query'
import type { AnamnesisSummary } from '@/features/anamneses/api'
import type { Appointment, ClinicContact } from '@/features/appointments/api'
import type { TreatmentPlanSummary } from '@/features/treatment-plans/api'
import { useApi } from '@/lib/api-context'

/**
 * O início (docs/api/portal.md, `GET /portal/home`; RN-POR-04, RN-POR-23): a pessoa, uma clínica
 * por cadastro e a linha do tempo de atendimentos, fichas de saúde e planos encerrados, de qualquer
 * clínica.
 */

export interface ClinicRow extends ClinicContact {
  patientSince: string
}

export interface Home {
  /** O e-mail confirmado no código. */
  email: string
  /** O documento da sessão, mascarado (RN-POR-01). */
  document: string
  session: { expiresAt: string }
  patient: { firstName: string; name: string }
  clinics: ClinicRow[]
  appointments: Appointment[]
  anamneses: AnamnesisSummary[]
  /** Os planos encerrados (RN-POR-23). */
  treatmentPlans: TreatmentPlanSummary[]
  counts: { all: number; appointments: number; anamneses: number; treatmentPlans: number }
  /** Cadastros com o mesmo documento em outro e-mail (RN-POR-21): só a contagem. */
  otherEmailRecords: number
}

export const homeKeys = {
  home: ['portal', 'home'] as const,
}

export function useHome() {
  const api = useApi()
  return useQuery({
    queryKey: homeKeys.home,
    queryFn: () => api.get<Home>('/portal/home'),
  })
}
